import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import N from 'Source/App/Main/Pages/Neumorphism/scripts';
import { selectEl } from 'Common/Utils';

const NavibarTypes = {
    as: PropTypes.elementType,
    className: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired
}

const Navibar = ({ as: Component = 'header', id, className, children}) => {
    useEffect(() => {
        const target = selectEl('.navibar-collapse')
        const backdrop = selectEl('.navibar-backdrop')
        const cleanUp = N.collapse.getInstance(target)
        const handleCollapse = (e) => { 
            backdrop.hidden = e.type === 'hide.n.collapse'
        }
        target.addEventListener('show.n.collapse', handleCollapse)
        target.addEventListener('hide.n.collapse', handleCollapse)
        return () => {  
            cleanUp.destroy()
            target.removeEventListener('show.n.collapse', handleCollapse)
            target.removeEventListener('hide.n.collapse', handleCollapse)
        }
    }, [])

    return (
        <>
            <Component id={id} className={`navibar ${className}`}>
                {children} 
            </Component>
            {ReactDOM.createPortal(
                <div className="navibar-backdrop" data-collapse="#navibar-collapse" hidden/>,
                document.body
            )}
        </>
    )
}

Navibar.propTypes = NavibarTypes

export default Navibar;